import { isEmpty } from "@utils/var.check.ts";
import { computed } from "vue";
import {
  INTEGRATOR_APP_FEATURE_CATEGORY,
  INTEGRATOR_APP_PROVIDER,
} from "@modules/app/service/app.constant.ts";
import store from "@plugins/store.ts";

export function useApp() {
  const getAppFeatureId = (category: string) => {
    const apps = store.getters["app/getIntegratorAppAccessByCategory"](category);
    const matchedApp = apps.find((app) => app.category === category);
    return matchedApp ? parseInt(matchedApp.appFeatureId) : null;
  };

  // Display name of the integrator app for the given category. Used to interpolate
  // the {feature_name} placeholder in the localized LLM error banner.
  const getAppFeatureName = (category: string): string => {
    const apps = store.getters["app/getIntegratorAppAccessByCategory"](category);
    const matchedApp = apps.find((app) => app.category === category);
    return matchedApp?.appFeatureName ?? "";
  };

  const isAppAvailable = (provider: string, category: string): boolean => {
    const apps = store.getters["app/getIntegratorAppAccessByCategory"](category);
    const appFound = apps.find((app) => app.provider === provider);
    if (isEmpty(appFound)) return false;
    return appFound.enabled && appFound.accessible;
  };

  const isAcpHtml5AppAvailable = computed(() => {
    return isAppAvailable(
      INTEGRATOR_APP_PROVIDER.ANTHROPIC,
      INTEGRATOR_APP_FEATURE_CATEGORY.ACP_HTML5,
    );
  });

  const isAcpModuleAppAvailable = computed(() => {
    return isAppAvailable(
      INTEGRATOR_APP_PROVIDER.OPENAI,
      INTEGRATOR_APP_FEATURE_CATEGORY.ACP_MODULE,
    );
  });

  const isAcpImageAppAvailable = computed(() => {
    return isAppAvailable(
      INTEGRATOR_APP_PROVIDER.OPENAI,
      INTEGRATOR_APP_FEATURE_CATEGORY.ACP_IMAGE,
    );
  });

  const isAcpGamificationAppAvailable = computed(() => {
    return isAppAvailable(
      INTEGRATOR_APP_PROVIDER.OPENAI,
      INTEGRATOR_APP_FEATURE_CATEGORY.ACP_GAMIFICATION,
    );
  });

  return {
    getAppFeatureId,
    getAppFeatureName,
    isAppAvailable,
    isAcpHtml5AppAvailable,
    isAcpModuleAppAvailable,
    isAcpImageAppAvailable,
    isAcpGamificationAppAvailable,
  };
}
